<div class="dialog-container">
  <div class="dialog-header">
    <h2>ADD TARIFF PLAN</h2>
    <button mat-icon-button class="close-button" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <form [formGroup]="tariffForm" (ngSubmit)="onSubmit()">
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Price Per Kwh (Rs)</mat-label>
          <input
            matInput
            type="number"
            formControlName="pricePerKwh"
            placeholder="Enter Price Per Kwh (Rs)">
          <mat-error *ngIf="tariffForm.get('pricePerKwh')?.hasError('required')">
            Price per kWh is required
          </mat-error>
          <mat-error *ngIf="tariffForm.get('pricePerKwh')?.hasError('min')">
            Price must be greater than 0
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>CGST (%)</mat-label>
          <input
            matInput
            type="number"
            formControlName="cgst"
            placeholder="Enter CGST (%)">
          <mat-error *ngIf="tariffForm.get('cgst')?.hasError('required')">
            CGST is required
          </mat-error>
          <mat-error *ngIf="tariffForm.get('cgst')?.hasError('min') || tariffForm.get('cgst')?.hasError('max')">
            CGST must be between 0 and 100
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>SGST (%)</mat-label>
          <input
            matInput
            type="number"
            formControlName="sgst"
            placeholder="Enter SGST (%)">
          <mat-error *ngIf="tariffForm.get('sgst')?.hasError('required')">
            SGST is required
          </mat-error>
          <mat-error *ngIf="tariffForm.get('sgst')?.hasError('min') || tariffForm.get('sgst')?.hasError('max')">
            SGST must be between 0 and 100
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>IGST (%)</mat-label>
          <input
            matInput
            type="number"
            formControlName="igst"
            placeholder="Enter IGST (%)">
          <mat-error *ngIf="tariffForm.get('igst')?.hasError('required')">
            IGST is required
          </mat-error>
          <mat-error *ngIf="tariffForm.get('igst')?.hasError('min') || tariffForm.get('igst')?.hasError('max')">
            IGST must be between 0 and 100
          </mat-error>
        </mat-form-field>
      </div>

      <div class="dialog-actions">
        <button class="add-button">
          Add Tariff
        </button>
      </div>
    </form>
  </div>
</div>
